

























































































import { useRouter, defineComponent, PropType, toRefs, onMounted, ref, computed } from '@nuxtjs/composition-api';
import { SfProductCard, SfAddToCart, SfButton, SfLink } from '@storefront-ui/vue';
import { useImage } from '~/composables';
import type { Product } from '~/modules/catalog/product/types';
import AddToWishlist from '~/components/AddToWishlist.vue';
import useWishlist from '~/modules/wishlist/composables/useWishlist';
/* import AddToCompare from '~/components/AddToCompare.vue'; */
/* import useComparelist from '~/modules/comparelist/composables/useComparelist'; */
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import CategoryProductPrice from '~/modules/catalog/category/components/views/CategoryProductPrice.vue';
import { useProductsWithCommonProductCardProps } from './useProductsWithCommonCardProps';
import { useUser } from '~/modules/customer/composables/useUser';
import { useCart } from '~/modules/checkout/composables/useCart';
import ProductStatusInfo from '~/components/ProductDetailPage/ProductStatusInfo.vue';

export default defineComponent({
  components: {
    CategoryProductPrice,
    AddToWishlist,
    SfProductCard,
    /* AddToCompare, */
    SkeletonLoader,
    SfAddToCart,
    SfButton,
    ProductStatusInfo,
    SfLink
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    eventcall : {
      type: Boolean,
      default: false
    },
    pricesLoaded: Boolean,
    loading: Boolean,
  },
  emits: ['click:wishlist', 'click:comparelist', 'click:add-to-cart', 'product-clicked'],
  setup(props, {emit}) {
    const { isAuthenticated, user, register, login, loading, load: loadUser } = useUser();
    const qty = ref([]);
    const { imageSizes: { productCard: imageSize } } = useImage();
    const { products } = toRefs(props);
    const { productsWithCommonProductCardProps } = useProductsWithCommonProductCardProps(products);    
    const { addOrRemoveItem, isInWishlist } = useWishlist();
    /* const { addOrRemoveItemToCompare, isInComparelist } = useComparelist(); */
    const { addItem, addedtocart_id: addedtocart_id, error: cartError, loading: isCartLoading, canAddToCart } = useCart();
    const addToCartError = computed(() => cartError.value?.addItem?.message);
    const router = useRouter();
    onMounted(async () => {
      //function saLoadScript(src) { var js = window.document.createElement('script'); js.src = src; js.type = 'text/javascript'; document.getElementsByTagName("head")[0].appendChild(js); } saLoadScript("https://www.shopperapproved.com/widgets/group2.0/31975.js");
      setTimeout(function () {
          if (process.client) {
              function saLoadScript(src) { 
                  var js = window.document.createElement('script'); 
                  js.src = src; 
                  js.type = 'text/javascript'; 
                  document.getElementsByTagName("head")[0].appendChild(js); 
              } 
              saLoadScript("https://www.shopperapproved.com/widgets/group2.0/31975.js");
          }
      }, 1000);
    });
    const addToCart = (product, qty) => {
      if (!qty) {
        qty = 1;
      }
      // @ts-ignore
      addItem({ product, quantity: parseInt(qty) });
    };

    const string_to_json = (message) => {
      const obj = JSON.parse(message);
      return obj;
    };

    const handleLinkClick = (event,url) => {
      if(event.target.tagName === 'BUTTON' || event.target.tagName === 'SPAN'){

      }else{
        router.push(url);
      }      
    }

    const savingPrice = (regularPrice, specialPrice) => {
      var regularPriceNum = regularPrice.replace(/\$/g, '');
      regularPriceNum = regularPriceNum.replace(/,/g, '');
      var specialPriceNum = specialPrice.replace(/\$/g, '');
      specialPriceNum = specialPriceNum.replace(/,/g, '');
      var saving = regularPriceNum - specialPriceNum;
      return Intl.NumberFormat('en-EN', { style: 'currency', currency: 'USD', }).format(saving)
    };

    const onProductClick = (product) => {
      if (props.eventcall) {
        emit('product-clicked', {
          product
        })
      }
    }

    return {
      handleLinkClick,
      imageSize,
      productsWithCommonProductCardProps,
      addItemToWishlist: addOrRemoveItem,
      /* addItemToComparelist: addOrRemoveItemToCompare, */
      isAuthenticated,
      qty,
      addToCart,
      addItem,
      canAddToCart,
      isCartLoading,
      string_to_json,
      savingPrice,
      addedtocart_id,
      onProductClick
    };
  },
});
